import React, {useState} from "react";
import './Sketchbook.css'
import Burger from './Hamburger.js'
import MobileNavBar from './MobileNavBar.js'

import Sketch0 from '../Images/Sketchbook/Sketch0.jpeg'
import Sketch1 from '../Images/Sketchbook/Sketch1.jpg'
import Sketch2 from '../Images/Sketchbook/Sketch2.jpeg'
import Sketch3 from '../Images/Sketchbook/Sketch3.jpeg'
import Sketch4 from '../Images/Sketchbook/Sketch4.jpeg'
import Sketch5 from '../Images/Sketchbook/Sketch5.jpg'
import Sketch6 from '../Images/Sketchbook/Sketch6.jpeg'
import Sketch7 from '../Images/Sketchbook/Sketch7.jpeg'
import Sketch8 from '../Images/Sketchbook/Sketch8.jpeg'
import Sketch9 from '../Images/Sketchbook/Sketch9.jpg'
import Sketch10 from '../Images/Sketchbook/Sketch10.jpeg'
import Sketch11 from '../Images/Sketchbook/Sketch11.jpeg'
import Sketch12 from '../Images/Sketchbook/Sketch12.jpg'
import Sketch13 from '../Images/Sketchbook/Sketch13.jpg'


export default function Sketchbook(){
	const [open, setOpen] = useState(false);

	return(
		<div>
			<div class="sketchbook-grid-container-main">
				<div class="sketchbookProject">
		    		<img className="sketchbookImage"src={Sketch13} loading="lazy"/>
		    		<div class="sketchbookOverlay">
                        <a></a>
		    		</div>
		    	</div>

				<div class="sketchbookProject">
		    		<img className="sketchbookImage"src={Sketch0} loading="lazy"/>
		    		<div class="sketchbookOverlay">
                        <a></a>
		    		</div>
		    	</div>

				<div class="sketchbookProject">
		    		<img className="sketchbookImage"src={Sketch1} loading="lazy"/>
		    		<div class="sketchbookOverlay">
                        <a></a>
		    		</div>
		    	</div>
		    	<div class="sketchbookProject">
		    		<img className="sketchbookImage"src={Sketch2} loading="lazy"/>
		    		<div class="sketchbookOverlay">
                        <a></a>
		    		</div>
		    	</div>
				<div class="sketchbookProject">
		    		<img className="sketchbookImage"src={Sketch3} loading="lazy"/>
		    		<div class="sketchbookOverlay">
                        <a></a>
		    		</div>
		    	</div>

				<div class="sketchbookProject">
		    		<img className="sketchbookImage"src={Sketch12} loading="lazy"/>
		    		<div class="sketchbookOverlay">
                        <a></a>
		    		</div>
		    	</div>

				<div class="sketchbookProject">
		    		<img className="sketchbookImage"src={Sketch5} loading="lazy"/>
		    		<div class="sketchbookOverlay">
                        <a></a>
		    		</div>
		    	</div>
		    	<div class="sketchbookProject">
		    		<img className="sketchbookImage"src={Sketch6} loading="lazy"/>
		    		<div class="sketchbookOverlay">
                        <a></a>
		    		</div>
		    	</div>
		    	<div class="sketchbookProject">
		    		<img className="sketchbookImage"src={Sketch7} loading="lazy"/>
		    		<div class="sketchbookOverlay">
                        <a></a>
		    		</div>
		    	</div>
				
		    	<div class="sketchbookProject">
		    		<img className="sketchbookImage"src={Sketch4} loading="lazy"/>
		    		<div class="sketchbookOverlay">
                        <a></a>
		    		</div>
		    	</div>
		    	

		    	<div class="sketchbookProject">
		    		<img className="sketchbookImage"src={Sketch8} loading="lazy"/>
		    		<div class="sketchbookOverlay">
                        <a></a>
		    		</div>
		    	</div>
		    	<div class="sketchbookProject">
		    		<img className="sketchbookImage"src={Sketch9} loading="lazy"/>
		    		<div class="sketchbookOverlay">
                        <a></a>
		    		</div>
		    	</div>
		    	<div class="sketchbookProject">
		    		<img className="sketchbookImage"src={Sketch10} loading="lazy"/>
		    		<div class="sketchbookOverlay">
                        <a></a>
		    		</div>
		    	</div>
		    	<div class="sketchbookProject">
		    		<img className="sketchbookImage"src={Sketch11} loading="lazy"/>
		    		<div class="sketchbookOverlay">
                        <a></a>
		    		</div>
		    	</div>
			</div>

			<div className="sketchbook-mobile">
				<div className="mobileNav">
					<Burger open={open} setOpen={setOpen}/>
					<MobileNavBar open={open} setOpen={setOpen}/>
				</div>
				<div className="mobileContent">
					<img className="designImage" src={Sketch1} loading="lazy"/>
					<img className="designImage" src={Sketch2} loading="lazy"/>
					<img className="designImage" src={Sketch3} loading="lazy"/>
					<img className="designImage" src={Sketch4} loading="lazy"/>
					<img className="designImage" src={Sketch5} loading="lazy"/>
					<img className="designImage" src={Sketch6} loading="lazy"/>
					<img className="designImage" src={Sketch7} loading="lazy"/>
					<img className="designImage" src={Sketch12} loading="lazy"/>
					<img className="designImage" src={Sketch8} loading="lazy"/>
					<img className="designImage" src={Sketch9} loading="lazy"/>
					<img className="designImage" src={Sketch10} loading="lazy"/>
					<img className="designImage" src={Sketch11} loading="lazy"/>


				</div>
			</div>
		</div>

	)
}
